<script lang="ts" setup>
import LogoIconSvg from '@/assets/images/logo-icon.svg';
import LogoTextSvg from '@/assets/images/logo-text.svg';
import { useWindowScroll } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import Button from 'primevue/button';
import { RouterLink } from 'vue-router';
import useLogout from '~/composables/auth/useLogout';
import NavLinks from './NavLinks.vue';

const { isAuthenticated } = storeToRefs(useAuthStore());
const { logout } = useLogout();

const { y } = useWindowScroll();

const isScrolled = computed(() => y.value > 10);
</script>

<template>
  <header
    class="sticky top-0 z-50 px-3 backdrop-blur transition-all duration-300 lg:px-4 xl:px-0"
    :class="{ 'bg-[#D8F1FF]': isScrolled }"
  >
    <div class="mx-auto flex h-20 max-w-6xl items-center justify-between">
      <div class="flex items-center justify-center gap-4 px-1.5 lg:gap-[59px]">
        <NuxtLink v-slot="{ navigate, href }" to="/" custom>
          <div
            :href="href"
            class="flex cursor-pointer items-center gap-2 text-lg font-bold"
            @click="navigate"
          >
            <LogoIconSvg filled :font-controlled="false" class="h-6 w-6" />
            <LogoTextSvg
              color="#306294"
              :font-controlled="false"
              class="h-[12.28px] w-[48.97px]"
            />
          </div>
        </NuxtLink>
        <div class="hidden lg:block">
          <NavLinks />
        </div>
      </div>

      <nav class="flex items-center gap-2 sm:gap-4">
        <template v-if="!isAuthenticated">
          <Button v-slot="slotProps" as-child>
            <RouterLink
              to="/auth/login"
              :class="slotProps.class"
              class="border-0! bg-white! font-semibold! text-black! hover:bg-slate-100! sm:w-[87px]"
            >
              Login
            </RouterLink>
          </Button>
          <Button v-slot="slotProps" as-child>
            <RouterLink
              to="/auth/register"
              :class="slotProps.class"
              class="font-semibold! sm:w-[103px]"
            >
              Sign Up
            </RouterLink>
          </Button>
        </template>
        <template v-else>
          <Button
            class="border-0! bg-white! font-semibold! text-black! hover:bg-slate-100! sm:w-[87px]"
            @click="logout"
          >
            Logout
          </Button>
          <Button v-slot="slotProps" as-child>
            <RouterLink
              to="/dashboard"
              :class="slotProps.class"
              class="font-semibold! sm:w-[113px]"
            >
              Dashboard
            </RouterLink>
          </Button>
        </template>
      </nav>
    </div>

    <div class="flex items-center justify-center pt-4 pb-4 lg:hidden">
      <NavLinks />
    </div>
  </header>
</template>
